<div class="loadingGraphic" *ngIf="processing | async"></div>